import React from 'react';
import styled from 'styled-components';

const AddCC = () => (
  <svg
    tabIndex={0}
    role="img"
    aria-label="Choose a new card for checkout"
    width="58"
    height="49"
    viewBox="0 0 58 49"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title id="uniqueTitleID">Choose a new card for checkout</title>
    <path
      d="M13.7075 16.0996H4.58341C4.43748 16.0996 4.29754 16.1582 4.19435 16.2625C4.09117 16.3667 4.0332 16.5082 4.0332 16.6556C4.0332 16.8031 4.09117 16.9445 4.19435 17.0488C4.29754 17.1531 4.43748 17.2117 4.58341 17.2117H13.7074C13.8534 17.2117 13.9933 17.1531 14.0965 17.0488C14.1997 16.9445 14.2577 16.8031 14.2577 16.6556C14.2577 16.5082 14.1997 16.3667 14.0965 16.2625C13.9933 16.1582 13.8534 16.0996 13.7074 16.0996H13.7075Z"
      fill="#313945"
      fillOpacity="0.4"
    />
    <path
      d="M25.4907 16.0996H16.3666C16.2207 16.0996 16.0807 16.1582 15.9776 16.2625C15.8744 16.3667 15.8164 16.5082 15.8164 16.6556C15.8164 16.8031 15.8744 16.9445 15.9776 17.0488C16.0807 17.1531 16.2207 17.2117 16.3666 17.2117H25.4907C25.6366 17.2117 25.7765 17.1531 25.8797 17.0488C25.9829 16.9445 26.0409 16.8031 26.0409 16.6556C26.0409 16.5082 25.9829 16.3667 25.8797 16.2625C25.7765 16.1582 25.6366 16.0996 25.4907 16.0996Z"
      fill="#313945"
      fillOpacity="0.4"
    />
    <path
      d="M45.5351 5.69237e-07H2.46492C1.812 -0.000442385 1.18562 0.261098 0.723418 0.727148C0.26122 1.1932 0.00102072 1.82563 0 2.48546L0 30.4316C0.000816783 31.092 0.260775 31.7251 0.72286 32.1921C1.18494 32.659 1.81143 32.9218 2.46492 32.9226H26.1183C26.7979 34.711 27.998 36.2492 29.5603 37.3342C31.1226 38.4192 32.9737 39 34.8694 39C36.765 39 38.6161 38.4192 40.1784 37.3342C41.7407 36.2492 42.9408 34.711 43.6204 32.9226H45.5351C46.1886 32.9218 46.8151 32.659 47.2771 32.1921C47.7392 31.7251 47.9992 31.092 48 30.4316V2.48546C47.999 1.82563 47.7388 1.19319 47.2766 0.727144C46.8144 0.261094 46.188 -0.000445334 45.5351 5.69237e-07ZM34.8665 37.8879C33.2673 37.8864 31.7027 37.4167 30.362 36.5355C29.0213 35.6543 27.962 34.3994 27.3122 32.9226C27.1475 32.564 27.0131 32.192 26.9106 31.8105C26.6977 31.066 26.5902 30.2947 26.5914 29.5197C26.5914 28.4211 26.8055 27.3333 27.2215 26.3184C27.6375 25.3034 28.2473 24.3812 29.0159 23.6044C29.7846 22.8276 30.6971 22.2114 31.7014 21.791C32.7057 21.3706 33.7821 21.1542 34.8692 21.1542C35.9563 21.1542 37.0327 21.3706 38.037 21.791C39.0413 22.2114 39.9538 22.8276 40.7225 23.6044C41.4911 24.3812 42.1009 25.3034 42.5169 26.3184C42.9329 27.3333 43.147 28.4211 43.147 29.5197C43.1483 30.2947 43.0409 31.066 42.8281 31.8105C42.725 32.1911 42.5925 32.5629 42.4318 32.9226C41.7796 34.3999 40.7182 35.6548 39.3758 36.5359C38.0334 37.417 36.4672 37.8866 34.8665 37.8879ZM46.8996 30.4316C46.8996 30.6127 46.8643 30.792 46.7957 30.9593C46.7272 31.1266 46.6267 31.2786 46.4999 31.4067C46.3732 31.5347 46.2228 31.6363 46.0573 31.7056C45.8917 31.7749 45.7143 31.8105 45.5351 31.8105H43.9669C44.1555 31.0619 44.2497 30.2922 44.2474 29.5197C44.2474 27.0061 43.2594 24.5954 41.5006 22.8181C39.7419 21.0407 37.3565 20.0422 34.8692 20.0422C32.382 20.0422 29.9966 21.0407 28.2378 22.8181C26.4791 24.5954 25.491 27.0061 25.491 29.5197C25.4887 30.2922 25.583 31.0619 25.7718 31.8105H2.46492C2.28572 31.8105 2.10828 31.7749 1.94273 31.7056C1.77717 31.6363 1.62675 31.5347 1.50004 31.4067C1.37333 31.2786 1.27282 31.1266 1.20425 30.9593C1.13568 30.792 1.1004 30.6127 1.10041 30.4316V11.7823H46.8996V30.4316ZM46.8996 10.6702H1.10041V6.16638H46.8996V10.6702ZM46.8996 5.05432H1.10041V2.48546C1.1005 2.30466 1.1359 2.12565 1.20457 1.9587C1.27324 1.79176 1.37384 1.64014 1.5006 1.51256C1.62736 1.38497 1.77779 1.28392 1.94327 1.21519C2.10874 1.14647 2.28601 1.11142 2.46492 1.11206H45.5351C45.714 1.11142 45.8912 1.14647 46.0567 1.21519C46.2222 1.28392 46.3726 1.38497 46.4994 1.51256C46.6262 1.64014 46.7267 1.79176 46.7954 1.9587C46.8641 2.12565 46.8995 2.30466 46.8996 2.48546L46.8996 5.05432Z"
      fill="#313945"
      fillOpacity="0.4"
    />
    <path
      d="M38.1155 29.5811C38.1155 29.508 38.1013 29.4357 38.0737 29.3683C38.046 29.3008 38.0055 29.2395 37.9544 29.1879C37.9033 29.1363 37.8427 29.0953 37.7759 29.0674C37.7092 29.0395 37.6376 29.0251 37.5654 29.0251L35.3587 29.0251L35.3587 26.7951C35.3587 26.6476 35.3008 26.5062 35.1976 26.4019C35.0944 26.2977 34.9545 26.2391 34.8086 26.2391C34.6627 26.2391 34.5227 26.2977 34.4196 26.4019C34.3164 26.5062 34.2584 26.6476 34.2584 26.7951L34.2584 29.0251L32.2949 29.0251C32.149 29.0251 32.0091 29.0836 31.9059 29.1879C31.8027 29.2922 31.7448 29.4336 31.7448 29.581C31.7448 29.7285 31.8027 29.8699 31.9059 29.9742C32.0091 30.0784 32.149 30.137 32.2949 30.137L34.2584 30.137V32.1213C34.2584 32.2688 34.3164 32.4102 34.4196 32.5144C34.4707 32.5661 34.5313 32.607 34.598 32.635C34.6648 32.6629 34.7363 32.6773 34.8086 32.6773C34.8808 32.6773 34.9524 32.6629 35.0191 32.635C35.0859 32.607 35.1465 32.5661 35.1976 32.5144C35.2487 32.4628 35.2892 32.4015 35.3168 32.3341C35.3445 32.2666 35.3587 32.1943 35.3587 32.1213L35.3587 30.137L37.5654 30.137C37.6376 30.137 37.7092 30.1227 37.7759 30.0947C37.8427 30.0668 37.9034 30.0259 37.9544 29.9742C38.0055 29.9226 38.0461 29.8613 38.0737 29.7938C38.1013 29.7264 38.1156 29.6541 38.1155 29.5811Z"
      fill="#313945"
      fillOpacity="0.4"
    />
  </svg>
);

const DiscoverSVG = () => (
  <svg
    tabIndex={0}
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 6 48 38"
    version="1.1"
    width="48px"
    height="40px"
    role="img"
    aria-label="Choose discover card for checkout"
  >
    <title id="uniqueTitleID">Choose discover card for checkout</title>
    <g id="surface1">
      <path
        style={{ fill: '#E1E7EA' }}
        d="M 45 35 C 45 37.199219 43.199219 39 41 39 L 7 39 C 4.800781 39 3 37.199219 3 35 L 3 13 C 3 10.800781 4.800781 9 7 9 L 41 9 C 43.199219 9 45 10.800781 45 13 Z "
      />
      <path
        style={{ fill: '#FF6D00' }}
        d="M 45 35 C 45 37.199219 43.199219 39 41 39 L 16 39 C 16 39 39.601563 35.199219 45 24 Z M 22 24 C 22 25.699219 23.300781 27 25 27 C 26.699219 27 28 25.699219 28 24 C 28 22.300781 26.699219 21 25 21 C 23.300781 21 22 22.300781 22 24 Z "
      />
      <path d="M 11.199219 21 L 12.300781 21 L 12.300781 27 L 11.199219 27 Z M 17.199219 24 C 17.199219 25.6992198 18.5 27 20.199219 27 C 20.699219 27 21.101563 26.898438 21.601563 26.699219 L 21.601563 25.398438 C 21.199219 25.800781 20.800781 26 20.199219 26 C 19.101563 26 18.300781 25.199219 18.300781 24 C 18.300781 22.898438 19.101563 22 20.199219 22 C 20.699219 22 21.101563 22.199219 21.601563 22.601563 L 21.601563 21.300781 C 21.101563 21.101563 20.699219 20.898438 20.199219 20.898438 C 18.5 21 17.199219 22.398438 17.199219 24 Z M 30.601563 24.898438 L 29 21 L 27.800781 21 L 30.300781 27 L 30.898438 27 L 33.398438 21 L 32.199219 21 Z M 33.898438 27 L 37.101563 27 L 37.101563 26 L 35 26 L 35 24.398438 L 37 24.398438 L 37 23.398438 L 35 23.398438 L 35 22 L 37.101563 22 L 37.101563 21 L 33.898438 21 Z M 41.5 22.800781 C 41.5 21.699219 40.800781 21 39.5 21 L 37.800781 21 L 37.800781 27 L 38.898438 27 L 38.898438 24.601563 L 39 24.601563 L 40.601563 27 L 42 27 L 40.199219 24.5 C 41 24.300781 41.5 23.699219 41.5 22.800781 Z M 39.199219 23.800781 L 38.898438 23.800781 L 38.898438 22 L 39.199219 22 C 39.898438 22 40.300781 22.300781 40.300781 22.898438 C 40.300781 23.398438 40 23.800781 39.199219 23.800781 Z M 7.699219 21 L 6 21 L 6 27 L 7.601563 27 C 10.101563 27 10.699219 24.898438 10.699219 24 C 10.800781 22.199219 9.5 21 7.699219 21 Z M 7.398438 26 L 7.101563 26 L 7.101563 22 L 7.5 22 C 9 22 9.601563 23 9.601563 24 C 9.601563 24.398438 9.5 26 7.398438 26 Z M 15.300781 23.300781 C 14.601563 23 14.398438 22.898438 14.398438 22.601563 C 14.398438 22.199219 14.800781 22 15.199219 22 C 15.5 22 15.800781 22.101563 16.101563 22.5 L 16.699219 21.699219 C 16.199219 21.199219 15.699219 21 15 21 C 14 21 13.199219 21.699219 13.199219 22.699219 C 13.199219 23.5 13.601563 23.898438 14.601563 24.300781 C 15.199219 24.5 15.699219 24.699219 15.699219 25.199219 C 15.699219 25.699219 15.300781 26 14.800781 26 C 14.300781 26 13.800781 25.699219 13.601563 25.199219 L 12.898438 25.898438 C 13.398438 26.699219 14 27 14.898438 27 C 16.101563 27 16.898438 26.199219 16.898438 25.101563 C 16.898438 24.199219 16.5 23.800781 15.300781 23.300781 Z " />
    </g>
  </svg>
);

const VisaSVG = () => (
  <svg
    tabIndex={0}
    role="img"
    aria-label="Choose Visa card for checkout"
    width="52"
    height="28"
    viewBox="0 0 52 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title id="uniqueTitleID">Choose VISA card for checkout</title>
    <rect width="52" height="28" rx="4" fill="white" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M33.7283 16.1175C33.7357 14.1956 32.2088 13.3654 31.024 12.7213C30.2739 12.3134 29.6608 11.9801 29.6608 11.4915C29.6608 11.0756 30.0493 10.6344 30.875 10.5209C31.8576 10.42 32.8481 10.5987 33.7404 11.0377L34.2503 8.51679C33.3805 8.17818 32.4596 8.00318 31.5306 8C28.6652 8 26.674 9.5882 26.674 11.8571C26.674 13.5335 28.1188 14.4662 29.2116 15.0208C30.3043 15.5755 30.7293 15.9662 30.7171 16.4704C30.7171 17.2519 29.8187 17.6048 28.9809 17.6174C27.9475 17.6312 26.9277 17.3709 26.0183 16.8611L25.4962 19.3821C26.5252 19.7991 27.6213 20.0087 28.7259 19.9997C31.7735 19.9997 33.7768 18.4367 33.789 16.0166L33.7283 16.1175ZM25.8482 8.20187L23.4198 19.8613H20.5059L22.9342 8.20187H25.8482ZM38.0625 15.7643L39.5923 11.3905L40.4787 15.7643H38.0625ZM44.0003 19.8987H41.3049L40.9528 18.1592H37.2982L36.7032 19.8987H33.6436L38.0024 9.09642C38.2033 8.58246 38.6823 8.24437 39.2166 8.23929H41.6449L44.0003 19.8987ZM17.0455 19.8234L21.7564 8.16397H18.5996L15.5764 16.0924L14.3622 9.34882C14.2547 8.66356 13.6833 8.16115 13.0145 8.16397H8.07285L8 8.5043C8.99117 8.70562 9.95391 9.03595 10.8654 9.48747C11.2537 9.67697 11.5167 10.0651 11.5575 10.5085L13.8765 19.8234H17.0455Z"
      fill="#2A2A6C"
    />
  </svg>
);

const MasterCardSVG = () => (
  <svg
    tabIndex={0}
    aria-label="Choose Mastercard for checkout"
    width="52"
    height="28"
    viewBox="0 0 52 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title id="uniqueTitleID">Choose MasterCard for checkout</title>
    <rect width="52" height="28" rx="4" fill="#F2F2F2" />
    <rect x="22.25" y="8.5" width="8.25" height="12" fill="#F26122" />
    <path
      d="M23.2042 14.5C23.1924 12.2052 24.2231 10.0319 26 8.60471C22.9598 6.18672 18.5925 6.53784 15.9682 9.41125C13.3439 12.2847 13.3439 16.7153 15.9682 19.5887C18.5925 22.4622 22.9598 22.8133 26 20.3953C24.2231 18.9681 23.1924 16.7948 23.2042 14.5Z"
      fill="#EA1D25"
    />
    <path
      d="M38 14.5C37.9982 17.3713 36.3768 19.9899 33.8237 21.245C31.2705 22.5001 28.2332 22.1717 26 20.3991C29.2168 17.8372 29.7739 13.1237 27.2448 9.86699C26.8822 9.39539 26.4642 8.97022 26 8.60087C28.2332 6.8283 31.2705 6.49992 33.8237 7.75502C36.3768 9.01013 37.9982 11.6287 38 14.5Z"
      fill="#F69E1E"
    />
  </svg>
);

const AmexSVG = () => (
  <svg
    tabIndex={0}
    role="img"
    aria-label="Choose American Express card for checkout"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 6 48 38"
    version="1.1"
    width="48px"
    height="40px"
  >
    <title id="uniqueTitleID">Choose American Express card for checkout</title>
    <g id="surface1">
      <path
        style={{ fill: '#1976D2' }}
        d="M 45 35 C 45 37.210938 43.210938 39 41 39 L 7 39 C 4.789063 39 3 37.210938 3 35 L 3 13 C 3 10.789063 4.789063 9 7 9 L 41 9 C 43.210938 9 45 10.789063 45 13 Z "
      />
      <path
        style={{ fill: '#FFFFFF' }}
        d="M 22.253906 20 L 20.140625 24.683594 L 18.039063 20 L 15.34375 20 L 15.34375 26.726563 L 12.339844 20 L 10.066406 20 L 7 26.980469 L 8.816406 26.980469 L 9.484375 25.421875 L 12.917969 25.421875 L 13.601563 26.980469 L 17.066406 26.980469 L 17.066406 21.796875 L 19.363281 26.980469 L 20.925781 26.980469 L 23.277344 21.886719 L 23.277344 26.980469 L 25 26.980469 L 25 20 Z M 10.136719 23.914063 L 11.160156 21.476563 L 12.226563 23.914063 Z "
      />
      <path
        style={{ fill: '#FFFFFF' }}
        d="M 37.882813 23.414063 L 41 20.019531 L 38.78125 20.019531 L 36.789063 22.183594 L 34.859375 20 L 28 20 L 28 26.980469 L 34.636719 26.980469 L 36.726563 24.671875 L 38.765625 27 L 40.976563 27 Z M 33.726563 25.515625 L 29.71875 25.515625 L 29.71875 24.136719 L 33.554688 24.136719 L 33.554688 22.8125 L 29.71875 22.8125 L 29.71875 21.503906 L 33.949219 21.515625 L 35.644531 23.414063 Z "
      />
    </g>
  </svg>
);

const PaypalPNG = () => (
  <img
    tabIndex={0}
    aria-label="Choose Paypal for checkout"
    title="Choose Paypal for checkout"
    src="https://www.paypalobjects.com/webstatic/en_US/i/buttons/PP_logo_h_100x26.png"
    alt="Choose Paypal for checkout"
  />
);

const JCBPNG = () => (
  <img
    tabIndex={0}
    aria-label="Choose JCB card for checkout"
    title="Choose JCB card for checkout"
    style={{ marginBottom: '0.4rem' }}
    src="https://assets.artifactuprising.com/assets/images/misc/jcb.png"
    alt="Choose JCB card for checkout"
  />
);

export enum CCCardType {
  ADD_NEW_CARD = 'AddNewCard',
  MASTERCARD = 'MasterCard',
  DISCOVER = 'Discover',
  PAYPAL = 'Paypal',
  VISA = 'Visa',
  AMEX = 'American Express',
  JCB = 'JCB',
  AFTERPAY = 'Afterpay'
}

interface CCIconProps {
  type: CCCardType;
}

const { ADD_NEW_CARD, VISA, PAYPAL, MASTERCARD, AMEX, DISCOVER, JCB } = CCCardType;

const CCIconWrapper = styled.div`
  display: inline-block;
  height: 40px;
`;

const CCIcon = ({ type }: CCIconProps): React.JSX.Element => {
  const iconMap = {
    [ADD_NEW_CARD]: <AddCC />,
    [MASTERCARD]: <MasterCardSVG />,
    [DISCOVER]: <DiscoverSVG />,
    [PAYPAL]: <PaypalPNG />,
    [VISA]: <VisaSVG />,
    [AMEX]: <AmexSVG />,
    [JCB]: <JCBPNG />
  };

  return <CCIconWrapper>{iconMap[type]}</CCIconWrapper>;
};

export default CCIcon;
